<template>
  <Modal
    v-model="_value"
    width="400"
    title="增加下发指令"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="sendCmdRef" v-model="sendCmd" :label-width="140">
      <FormItem prop="terminalNum" label="主机号/终端号">
        <Input v-model="sendCmd.terminalNum" style="width: 180px;" placeholder="请输入主机号/终端号">
        </Input>
      </FormItem>
      <FormItem prop="automaticSending" label="是否设备上线自动下发">
        <Checkbox v-model="sendCmd.automaticSending"></Checkbox>
      </FormItem>
      <FormItem prop="timedTransmission" label="是否定时下发">
        <Checkbox v-model="sendCmd.timedTransmission"></Checkbox>
      </FormItem>
      <FormItem prop="intervalTime" label="定时下发间隔时间">
        <Select :disabled="!sendCmd.timedTransmission" v-model="sendCmd.intervalTime" style="width: 220px;">
          <Option v-for="item in timedTransmissionOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="cmdList" label="指令列表">
        <Input v-model="sendCmd.firstcmd" style="width: 180px;" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd==''" v-model="sendCmd.secondcmd" style="width: 180px;" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.thirdcmd" style="width: 180px;" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.fourthcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.fifthcmd" placeholder="请输入指令">
        </Input>
        <Input :disabled="sendCmd.firstcmd==null || sendCmd.firstcmd=='' || sendCmd.secondcmd==null || sendCmd.secondcmd==''" v-model="sendCmd.sixthcmd" placeholder="请输入指令">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'jt808addsengcmdmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sendCmd: {
        terminalNum: null,
        automaticSending: false,
        timedTransmission: false,
        intervalTime: null,
        firstcmd: null,
        secondcmd: null,
        thirdcmd: null,
        fourthcmd: null,
        fifthcmd: null,
        sixthcmd: null,
      },

      timedTransmissionOptions:[
        {name: '5分钟', value: 300},
        {name: '15分钟', value: 900},
        {name: '1小时', value: 3600},
      ],
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    onOk(){
      console.log(this.sendCmd)
      store.dispatch('SendCmdServ_AddObj',{
        params:this.sendCmd,
        urlparams:null
      }).then(res => {
        console.log(res)
        this.$emit('on-success')
      }).catch(err => {
        console.log(err)
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        this.sendCmd.terminalNum = null
        this.sendCmd.automaticSending = false
        this.sendCmd.timedTransmission = false
        this.sendCmd.intervalTime = null
        this.sendCmd.intervalTime = null
        this.sendCmd.firstcmd = null
        this.sendCmd.secondcmd = null
        this.sendCmd.thirdcmd = null
        this.sendCmd.fourthcmd = null
        this.sendCmd.fifthcmd = null
        this.sendCmd.sixthcmd = null

      }
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
